import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MedpaceDatepickerComponent } from '@components/atoms/medpace-datepicker/medpace-datepicker.component';
import {
    MdsButtonComponent,
    MdsDialogActionsComponent,
    MdsDialogComponent,
    MdsDialogContentComponent,
} from '@medpacesoftwaredevelopment/designsystem';
import { PersistentFormControl } from '@utility/persistent-forms';
import { Moment } from 'moment';

@Component({
    selector: 'medpace-generate-stipend-request-modal',
    imports: [
        MdsDialogComponent,
        MdsDialogActionsComponent,
        MdsDialogContentComponent,
        MdsButtonComponent,
        MedpaceDatepickerComponent,
    ],
    templateUrl: './generate-stipend-request-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenerateStipendRequestModalComponent {
    dialogRef: MatDialogRef<GenerateStipendRequestModalComponent> = inject(
        MatDialogRef<GenerateStipendRequestModalComponent>
    );
    data = signal<Moment>(inject(MAT_DIALOG_DATA)); // create signal from input data

    generateStipendRequestFormGroup = new FormGroup({
        visitDateFormControl: new PersistentFormControl<Moment>(null, [Validators.required]),
    });

    onGetVisitDate = effect(() => {
        if (!this.data()) return;
        this.generateStipendRequestFormGroup.controls.visitDateFormControl.setValue(this.data());
    });

    closeDialog(): void {
        this.dialogRef.close();
    }

    saveDialog(): void {
        if (this.generateStipendRequestFormGroup.valid) {
            this.dialogRef.close(this.generateStipendRequestFormGroup?.controls.visitDateFormControl.value);
        }
    }
}
